export default "__VITE_ASSET__cKF1DvtG__"